/* ChazaCo — offsets propios para los sticky bars de mobile-search y dept-nav.
   El --header-height nativo de Dawn mide .section-header (el wrapper de
   Shopify para TODA la seccion), que en ChazaCo tambien incluye
   chazaco-mobile-search y chazaco-dept-nav (renderizados despues de
   </sticky-header> en header.liquid). Usar --header-height como top de estos
   mismos elementos crea un offset circular y hace que se superpongan.
   Medimos por separado: .chz-header-wrap es solo la barra de header real. */
(function () {
  function updateOffsets() {
    var headerBar = document.querySelector('.chz-header-wrap');
    var mobileSearch = document.querySelector('.chz-mobile-search');
    if (!headerBar) return;

    var barHeight = headerBar.offsetHeight;
    var searchHeight = mobileSearch && mobileSearch.offsetParent !== null ? mobileSearch.offsetHeight : 0;

    document.documentElement.style.setProperty('--chz-header-bar-height', barHeight + 'px');
    document.documentElement.style.setProperty('--chz-dept-nav-top', (barHeight + searchHeight) + 'px');
  }

  var debounceId;
  function scheduleUpdate() {
    clearTimeout(debounceId);
    debounceId = setTimeout(updateOffsets, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateOffsets);
  } else {
    updateOffsets();
  }
  window.addEventListener('load', updateOffsets);
  window.addEventListener('resize', scheduleUpdate);
})();
